<template>
	<v-dialog width="300px" v-model="dialog">
		<v-card class="pa-2">
			<v-text-field label="New Screen Name" v-model="new_screen_name" :placeholder="screenName"></v-text-field>
		</v-card>
		<template v-slot:activator="{ on }">
			<v-chip v-on="on" dark small color="green" append-icon="mdi-pencil">{{screenName}} </v-chip> 
		</template>
	</v-dialog>
</template>

<style lang="less">
	
</style>

<script type="text/javascript">
	import Vuex from "vuex";
	// import - from "@/components/"
	export default {
		name: "ScreenName", 
		props: {
			user: {},
			screenName: {}
		},
		data: () => {
			return {
				dialog: false, 
				new_screen_name: false
			}
		},
		computed: {
			...Vuex.mapState({
				room: state => state.video.id
			})
		},
		created(){
			this.new_screen_name = this.screenName;
		},
		watch: {
			new_screen_name(){
				if( !this.new_screen_name ){
					return;
				}
				var doc = "videoRooms/" + this.room + "/participants/" + this.user;
				this.$store.dispatch("updateDoc", {
					doc: doc, 
					data: {screenName: this.new_screen_name }, 
					action: "update"
				})
			}
		}
	}
// </script>"